import moment from "moment";
import React, { memo } from "react";
import { FlatList, StyleSheet, View, Text, Image } from "react-native";
import { FONT_FAMILY, images, THEME_COLORS } from "../themes";

interface VerticalTimelineComponentProps {
  data: any[];
}

interface ILineWithText {
  isLast: boolean;
  label: string;
  time: string;
  text: string;
  color: string;
}

const LineWithText = (props: ILineWithText) => {
  const { isLast, time, text, color, label } = props;

  return (
    <View style={{ justifyContent: "center" }}>
      <View style={styles.container}>
        <View style={{flexDirection: 'row'}}>
          <View style={{alignItems: 'center'}}>
            <Image
              resizeMode="contain"
              source={images.pointIcon}
              style={[styles.point, { tintColor: time ? THEME_COLORS.success : THEME_COLORS.sideMenuGrey }]}
            />
            {isLast ? (
              null
            ) : (
              <View style={[styles.line, { backgroundColor: color==="#333333" ? THEME_COLORS.sideMenuGrey : color }]} />
            )}
          </View>
          <View style={{ paddingLeft: 20, bottom: 9}}>
            <Text
              style={{
              color: THEME_COLORS.primary,
              fontFamily: FONT_FAMILY.three,
              fontSize: 15,
              }}
            >
              {text}
            </Text>
            {
              <Text style={{ fontFamily: FONT_FAMILY.two, fontSize: 12, color: THEME_COLORS.textGrey }}>
                {time ? `${moment(time).format("Do MMM 'YY")} at ${moment(time).format("h:mm A")} ` : label !== 'Not Applicable' ? '' : '--'}
                <Text style={{ fontFamily: FONT_FAMILY.three, fontSize: 12, color: color }}>
                  {label !== 'Not Applicable' && `(${label})`}
                </Text>
              </Text>
            }
          </View>
        </View>
      </View>
    </View>
  );
};

const VerticalTimelineComponentV3 = ({ data }: VerticalTimelineComponentProps) => {
  return (
      <FlatList
        data={data}
        style={{ height: '92vh', paddingTop: 50, paddingBottom: 160 }}
        keyExtractor={(_, index) => index.toString()}
        renderItem={({ item, index }) => {
          const { color, journeyText, journeyTime, label } = item;

          let isLast = index === data.length - 1;

          return (
            <LineWithText
              key={index.toString()}
              isLast={isLast}
              time={journeyTime}
              text={journeyText}
              color={color}
              label={label}
            />
          );
        }}
      />
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
  },
  point: {
    width: 18,
    height: 20,
  },
  line: {
    width: 2,
    height: 86,
  },
});

export default memo(VerticalTimelineComponentV3);
